import { createRouter, createWebHistory } from 'vue-router'
import { usePageStore } from '@/stores/page'
import routes from './routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach((to, _, next) => {
  const page = usePageStore()

  if (!to.meta.title) {
    throw new Error('Page must have a title.')
  }

  page.setPageTitle(to.meta.title)

  next()
})

export default router

/**
 * Make sure all routes has meta with these attributes.
 */
declare module 'vue-router' {
  interface RouteMeta {
    title: string,
  }
}
